import { render, staticRenderFns } from "./singapore.vue?vue&type=template&id=723056cd&scoped=true&"
import script from "./singapore.vue?vue&type=script&lang=js&"
export * from "./singapore.vue?vue&type=script&lang=js&"
import style0 from "./singapore.vue?vue&type=style&index=0&id=723056cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723056cd",
  null
  
)

export default component.exports